import {
  BRANDS,
  MARKETS,
  POINT_IN_TIME,
  PRE_POST,
  TREND,
  FILTERSV2,
  SEGMENTS,
  PERIOD_TYPE,
  PERIOD,
  PRE_PERIOD_TYPE,
  PRE_PERIOD_START_DATE,
  PRE_PERIOD_END_DATE,
  STAT_TEST,
  BASE,
  MODE,
  PERIOD_START_DATE,
  PERIOD_END_DATE,
  VISUALIZATION_TYPE,
  METRIC,
  RESPONSE,
  QUESTION_OPTIONS,
  GROUPED_BY,
  BUTTERLFY,
  SECONDARY_BRANDS,
  DIFFERENTIATION,
  PERCEPTUAL,
  DISTRIBUTION,
  SCORE_TYPE,
  PROFILE_GROUP,
  PROFILE_METRIC,
  PROFILE_RESPONSE,
  TRENDS_METRIC,
  VIEW_ID,
  URL_BY_BRAND,
  URL_BY_SEGMENT,
  URL_BY_MARKET,
  URL_BY_MODEL,
  CATEGORY,
  HUMAN_METRIC,
  MODELS,
} from "@/constant/constantsThrougoutProject";
import type { ChildRoute } from "./routes.types";

export const equityBysegment: ChildRoute = {
  id: `equity/${URL_BY_SEGMENT}`,
  redirectTo: `/equity/${URL_BY_SEGMENT}`,
  icon: undefined,
  name: "By Segment",
  useSegmentSelect: true,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  useSegmentAsFilters: false,
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [DISTRIBUTION]: [SEGMENTS],
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const equityBybrand: ChildRoute = {
  id: `equity/${URL_BY_BRAND}`,
  redirectTo: `/equity/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, BRANDS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const equityBymarket: ChildRoute = {
  id: `equity/${URL_BY_MARKET}`,
  redirectTo: `/equity/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, MARKETS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
      VISUALIZATION_TYPE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const conversionBysegment: ChildRoute = {
  id: `conversion/${URL_BY_SEGMENT}`,
  redirectTo: `/conversion/${URL_BY_SEGMENT}`,
  icon: undefined,
  name: "By Segment",
  useSegmentSelect: true,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
      VISUALIZATION_TYPE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [DISTRIBUTION]: [SEGMENTS],
  },

  //added some base restriction in trend screens level also for conversion
  disableBases: ["AWARE", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const conversionBybrand: ChildRoute = {
  id: `conversion/${URL_BY_BRAND}`,
  redirectTo: `/conversion/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, DISTRIBUTION],
  useSegmentAsFilters: true,
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, BRANDS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  //added some base restriction in trend screens level also for conversion
  disableBases: ["AWARE", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};
export const conversionBymarket: ChildRoute = {
  id: `conversion/${URL_BY_MARKET}`,
  redirectTo: `/conversion/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, MARKETS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  //added some base restriction in trend screens level also for conversion
  disableBases: ["AWARE", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const emotionalBysegment: ChildRoute = {
  id: `emotional/${URL_BY_SEGMENT}`,
  redirectTo: `/emotional/${URL_BY_SEGMENT}`,
  icon: undefined,
  name: "By Segment",
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  useSegmentSelect: true,
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [DISTRIBUTION]: [SEGMENTS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
      VISUALIZATION_TYPE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};
export const emotionalBybrand: ChildRoute = {
  id: `emotional/${URL_BY_BRAND}`,
  redirectTo: `/emotional/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [
    TREND,
    POINT_IN_TIME,
    PRE_POST,
    DISTRIBUTION,
    DIFFERENTIATION,
    PERCEPTUAL,
    BUTTERLFY,
  ],
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, BRANDS],
    [DIFFERENTIATION]: [FILTERSV2, SEGMENTS, SECONDARY_BRANDS],
    [PERCEPTUAL]: [FILTERSV2, SEGMENTS, BRANDS],
    [BUTTERLFY]: [FILTERSV2, SEGMENTS, SECONDARY_BRANDS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],

    [DIFFERENTIATION]: [
      MARKETS,
      BRANDS,
      SECONDARY_BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PERCEPTUAL]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [BUTTERLFY]: [
      MARKETS,
      BRANDS,
      SECONDARY_BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};
export const emotionalBymarket: ChildRoute = {
  id: `emotional/${URL_BY_MARKET}`,
  redirectTo: `/emotional/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, MARKETS],
  },
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"]
};

export const advertisingBysegment: ChildRoute = {
  id: `advertising/${URL_BY_SEGMENT}`,
  redirectTo: `/advertising/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [DISTRIBUTION]: [SEGMENTS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      min: "2022-09-21",
      max: null,
    },
    [POINT_IN_TIME]: {
      [DISTRIBUTION]: {
        ADVERTISING: {
          min: "2022-09-21",
          max: null,
        },
      },
      min: "2022-09-21",
      max: null,
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const advertisingBybrand: ChildRoute = {
  id: `advertising/${URL_BY_BRAND}`,
  redirectTo: `/advertising/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, DISTRIBUTION],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VIEW_ID,
      VISUALIZATION_TYPE,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, BRANDS],
  },

  disableBases: ["USER", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      min: "2022-09-21",
      max: null,
    },
    [POINT_IN_TIME]: {
      [DISTRIBUTION]: {
        ADVERTISING: {
          min: "2022-09-21",
          max: null,
        },
      },
      min: "2022-09-21",
      max: null,
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const advertisingBymarket: ChildRoute = {
  id: `advertising/${URL_BY_MARKET}`,
  redirectTo: `/advertising/${URL_BY_MARKET}`,
  icon: undefined,
  useSegmentAsFilters: true,
  name: "By Market",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, MARKETS],
  },

  disableBases: ["USER", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      min: "2022-09-21",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [DISTRIBUTION]: {
        ADVERTISING: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};

export const brandVisibilityBysegment: ChildRoute = {
  id: `visibility/${URL_BY_SEGMENT}`,
  redirectTo: `/visibility/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [DISTRIBUTION]: [SEGMENTS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      adRecall: {
        min: "2022-09-21",
        max: null,
      },
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [DISTRIBUTION]: {
        VISIBILITY: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const brandVisibilityBybrand: ChildRoute = {
  id: `visibility/${URL_BY_BRAND}`,
  redirectTo: `/visibility/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, DISTRIBUTION],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, BRANDS],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      adRecall: {
        min: "2022-09-21",
        max: null,
      },
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [DISTRIBUTION]: {
        VISIBILITY: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};
export const brandVisibilityBymarket: ChildRoute = {
  id: `visibility/${URL_BY_MARKET}`,
  redirectTo: `/visibility/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
  },
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, MARKETS],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
  dates: {
    [TREND]: {
      adRecall: {
        min: "2022-09-21",
        max: null,
      },
    },
    [POINT_IN_TIME]: {
      min: "2022-09-21",
      max: null,
      [DISTRIBUTION]: {
        VISIBILITY: {
          min: "2022-09-21",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2022-09-21",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from September 21, 2022.",
};

export const exclusiveQuestionsBybrand: ChildRoute = {
  id: `exclusivequestions/${URL_BY_BRAND}`,
  redirectTo: `/exclusivequestions/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      VIEW_ID
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      METRIC,
      RESPONSE,
      VIEW_ID
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS, QUESTION_OPTIONS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS, QUESTION_OPTIONS],
    [PRE_POST]: [FILTERSV2, SEGMENTS, QUESTION_OPTIONS, BRANDS],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
};

export const exclusiveQuestionsBysegment: ChildRoute = {
  id: `exclusivequestions/${URL_BY_SEGMENT}`,
  redirectTo: `/exclusivequestions/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS, QUESTION_OPTIONS],
    [POINT_IN_TIME]: [SEGMENTS, QUESTION_OPTIONS],
    [PRE_POST]: [SEGMENTS, QUESTION_OPTIONS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      GROUPED_BY,
      QUESTION_OPTIONS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
    ],
  },

  disableBases: ["USER", "ADRECALL", "RQ_GENPOP"],
  defaultBase: ["GENPOP"],
};

export const reputationBysegment: ChildRoute = {
  id: `reputation/${URL_BY_SEGMENT}`,
  redirectTo: `/reputation/${URL_BY_SEGMENT}`,
  useSegmentSelect: true,
  icon: undefined,
  useSegmentAsFilters: false,
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [SEGMENTS],
    [POINT_IN_TIME]: [SEGMENTS],
    [PRE_POST]: [SEGMENTS],
    [DISTRIBUTION]: [SEGMENTS],
  },
  name: "By Segment",
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      VIEW_ID,
      TRENDS_METRIC,
      RESPONSE,
      SCORE_TYPE,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      METRIC,
      RESPONSE,
      SCORE_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      VIEW_ID,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      SCORE_TYPE,
    ],
  },

  //added some base restriction in screens level also for reputation based on scoretype
  disableBases: ["USER", "ADRECALL", "AWARE", "GENPOP", "RQ_GENPOP"],
  defaultBase: ["FAMILIAR"],
  dates: {
    [TREND]: {
      min: "2025-11-17",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2025-11-17",
      max: null,
      [DISTRIBUTION]: {
        REPUTATION: {
          min: "2025-11-17",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2025-11-17",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from November 17, 2025.",
};
export const reputationBybrand: ChildRoute = {
  id: `reputation/${URL_BY_BRAND}`,
  redirectTo: `/reputation/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: true,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST, DISTRIBUTION],
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      METRIC,
      RESPONSE,
      SCORE_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      TRENDS_METRIC,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
  },
  multipleOptionsForKeys: {
    [TREND]: [BRANDS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [BRANDS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, BRANDS],
  },

  //added some base restriction in screens level also for reputation based on scoretype
  disableBases: ["USER", "ADRECALL", "AWARE", "GENPOP", "RQ_GENPOP"],
  defaultBase: ["FAMILIAR"],
  dates: {
    [TREND]: {
      min: "2025-11-17",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2025-11-17",
      max: null,
      [DISTRIBUTION]: {
        REPUTATION: {
          min: "2025-11-17",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2025-11-17",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from November 17, 2025.",
};
export const reputationBymarket: ChildRoute = {
  id: `reputation/${URL_BY_MARKET}`,
  redirectTo: `/reputation/${URL_BY_MARKET}`,
  icon: undefined,
  name: "By Market",
  useSegmentAsFilters: true,
  urlKeysMapping: {
    [TREND]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PERIOD,
      VISUALIZATION_TYPE,
      TRENDS_METRIC,
      RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [POINT_IN_TIME]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      METRIC,
      RESPONSE,
      SCORE_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      VIEW_ID,
    ],
    [PRE_POST]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      SCORE_TYPE,
      VIEW_ID,
    ],
    [DISTRIBUTION]: [
      MARKETS,
      BRANDS,
      SEGMENTS,
      FILTERSV2,
      STAT_TEST,
      BASE,
      MODE,
      PERIOD_TYPE,
      PERIOD_START_DATE,
      PERIOD_END_DATE,
      VISUALIZATION_TYPE,
      PROFILE_GROUP,
      PROFILE_METRIC,
      PROFILE_RESPONSE,
      SCORE_TYPE,
      VIEW_ID,
    ],
  },
  modeOptions: [TREND, POINT_IN_TIME, DISTRIBUTION],
  multipleOptionsForKeys: {
    [TREND]: [MARKETS, FILTERSV2, SEGMENTS],
    [POINT_IN_TIME]: [MARKETS, FILTERSV2, SEGMENTS],
    [PRE_POST]: [FILTERSV2, SEGMENTS],
    [DISTRIBUTION]: [FILTERSV2, SEGMENTS, MARKETS],
  },

  //added some base restriction in screens level also for reputation based on scoretype
  disableBases: ["USER", "ADRECALL", "AWARE", "GENPOP", "RQ_GENPOP"],
  defaultBase: ["FAMILIAR"],
  dates: {
    [TREND]: {
      min: "2025-11-17",
      max: null,
    },
    [POINT_IN_TIME]: {
      min: "2025-11-17",
      max: null,
      [DISTRIBUTION]: {
        REPUTATION: {
          min: "2025-11-17",
          max: null,
        },
      },
    },
    [PRE_POST]: {
      min: "2025-11-17",
      max: null,
    },
  },
  warningMessage:
    "Data for the previous time period comparison is only available from November 17, 2025.",
};

export const reports: ChildRoute = {
  id: "reports",
  redirectTo: "/reports",
  icon: undefined,
  name: "Reports",
  useSegmentAsFilters: false,
  modeOptions: [],
  urlKeysMapping: {},
  multipleOptionsForKeys: {},

};

const aiVisibilityCommonKeys = [
  MARKETS,
  BRANDS,
  CATEGORY,
  STAT_TEST,
  BASE,
  MODE,
  PERIOD_TYPE,
  PERIOD_START_DATE,
  PERIOD_END_DATE,
  VISUALIZATION_TYPE,
  VIEW_ID,
];

export const aiVisibilityBybrand: ChildRoute = {
  id: `aivisibility/${URL_BY_BRAND}`,
  redirectTo: `/aivisibility/${URL_BY_BRAND}`,
  icon: undefined,
  name: "By Brand",
  useSegmentAsFilters: false,
  useSegmentSelect: false,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST],
  multipleOptionsForKeys: {
    [TREND]: [BRANDS],
    [POINT_IN_TIME]: [BRANDS],
    [PRE_POST]: [BRANDS],
  },
  urlKeysMapping: {
    [TREND]: [...aiVisibilityCommonKeys, PERIOD, TRENDS_METRIC, MODELS],
    [POINT_IN_TIME]: [...aiVisibilityCommonKeys, MODELS, HUMAN_METRIC],
    [PRE_POST]: [
      ...aiVisibilityCommonKeys,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      MODELS,
      TRENDS_METRIC,
    ],
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP", "FAMILIAR", "AWARE"],
  defaultBase: ["GENPOP"],
};

export const aiVisibilityBymodel: ChildRoute = {
  id: `aivisibility/${URL_BY_MODEL}`,
  redirectTo: `/aivisibility/${URL_BY_MODEL}`,
  icon: undefined,
  name: "By Model",
  useSegmentAsFilters: false,
  useSegmentSelect: false,
  modeOptions: [TREND, POINT_IN_TIME, PRE_POST],
  multipleOptionsForKeys: {
    [TREND]: [],
    [POINT_IN_TIME]: [],
    [PRE_POST]: [],
  },
  urlKeysMapping: {
    [TREND]: [...aiVisibilityCommonKeys, PERIOD, TRENDS_METRIC, MODELS],
    [POINT_IN_TIME]: [...aiVisibilityCommonKeys, MODELS, HUMAN_METRIC],
    [PRE_POST]: [
      ...aiVisibilityCommonKeys,
      PRE_PERIOD_TYPE,
      PRE_PERIOD_START_DATE,
      PRE_PERIOD_END_DATE,
      MODELS,
    ],
  },
  disableBases: ["USER", "ADRECALL", "RQ_GENPOP", "FAMILIAR", "AWARE"],
  defaultBase: ["GENPOP"],
};
